import { FC, useEffect, useState } from "react";
import Card from "antd/es/card/Card";
import { Button, Input, message, Form} from "antd";
import { useNavigate } from "react-router-dom";
import { MailRequest } from "../../shared/types/request/mail.model";
import { TokenValid } from "../../shared/types/request/tokenvalid.model";
import { useIsTokenValid } from "../../shared/services/security/security.service";
import { useForgetPassword } from "../../shared/services/forgetpassword/forgetpassword.service";

const ForgetPassword : FC = () => {

    const navigate = useNavigate()
    
    function retourVersConnexion() {
        navigate("/connexion");
    }

    const[tokenRequest, setTokenRequest] = useState<TokenValid>();
    
    const {dataToken} = useIsTokenValid(tokenRequest);
    
    useEffect(() => {
        if(localStorage.getItem("username") && localStorage.getItem("token")){
            const request: TokenValid = {
                username: localStorage.getItem("username") || "",
                token: localStorage.getItem("token") || ""
            };
            setTokenRequest(request);
        }
    }, [])
    
    useEffect(() => {
        if(dataToken){
            navigate("/espaceuser");
        }
    }, [dataToken])

    const[messageApi, contextHolder] = message.useMessage();
    const[formValues, setFormValues] = useState<MailRequest>();

    const onFinish = (values: MailRequest) => {
        setFormValues(values);
    };

    const{data, isLoading, error} = useForgetPassword(formValues);

        useEffect(() =>{
        if(error && error.response.data.erreur){
            messageApi.error(error.response.data.erreur);
        }else{
            if(error)
            {
                messageApi.error(error.message);
            }
        }
        setFormValues(undefined);
    }, [error])

    useEffect(() => {
        if(data && data.ok){
            messageApi.success(data.ok);
        }
        setFormValues(undefined);
    }, [data])

    return(
        <Card title={<span style={{ textAlign: "center" }}>Récupérez votre Nom d'Utilisateur ou mot de passe en entrant votre adresse mail</span>} variant="borderless" className="responsive-card">
            {contextHolder}
            <div style={{paddingLeft:"5%", paddingRight:"30%"}}>
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Adresse mail"
                        name="mail"
                        rules={[
                            {required: true, message: "Adresse mail requis"},
                            { type:"email", message: "Email invalide"}
                        ]}
                    >
                        <Input placeholder="Adresse mail" />
                    </Form.Item>
                    <Button type="primary" loading={isLoading} htmlType="submit">
                        Valider
                    </Button>
                </Form>
            </div>
            <Button onClick={retourVersConnexion} style={{ marginTop: "50px" }}>Retour</Button>
        </Card>
    );
}

export default ForgetPassword;